import React, { useState, useEffect } from "react";
import "../styles/Strategies.css";

const Strategies = () => {
  // If you want to check on initial render only:
  const [isDesktop, setIsDesktop] = useState(
    typeof window !== "undefined" && window.innerWidth >= 1024
  );

  if (isDesktop) {
    // --- DESKTOP LAYOUT ---
    return (
      <div className="strategies-container-desktop">
        {/* Left Column: Title & Subtitle */}
        <div className="strategies-left-desktop">
          <h1 className="strategies-title-desktop">Strategies</h1>
          <p className="strategies-subtitle-desktop">By Nexavista</p>
        </div>

        {/* Right Column: Description, Highlights, and Button */}
        <div className="strategies-right-desktop">
          <p className="strategies-description-desktop">
            The <strong>Strategies Dashboard</strong> will allow you to analyze
            your business metrics, identify patterns, and plan the best
            strategies for growth.
          </p>

          <p className="strategies-highlight-desktop">
            Gain access to valuable insights, <strong>all in one place.</strong>
          </p>

          <p className="coming-soon-desktop">Coming Soon..</p>
          <button className="notify-button-desktop">Notify Me by Email</button>
        </div>
      </div>
    );
  } else {
    // --- MOBILE LAYOUT ---
    return (
      <div className="strategies-container">
        <h1 className="strategies-title">Strategies</h1>
        <p className="strategies-subtitle">By Nexavista</p>

        <p className="strategies-description">
          The <strong>Strategies Dashboard</strong> will allow you to analyze
          your business metrics, identify patterns, and plan the best strategies
          for growth.
        </p>

        <p className="strategies-highlight">
          Gain access to valuable insights, <strong>all in one place.</strong>
        </p>

        <p className="coming-soon">Coming Soon..</p>
        <button className="notify-button">Notify Me by Email</button>
      </div>
    );
  }
};

export default Strategies;
